module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper relatorio_execucao",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.modoEdicao ? 'Editando os Relatórios de Execução' : 'Relatórios de Execução') + "\n\n        "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.carregando && !_vm.loading.processando && _vm.relatorios.length > 0) ? _c('span', [(_vm.modoEdicao) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.concluirAlteracaoListaRelatorios($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelarAlteracaoListaRelatorios($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.alterarListaRelatorios($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Alterar Cronograma")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Vai para a tela deste Projeto</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'projeto',
          params: {
            numero: _vm.projeto.numero
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-label": "false"
    }
  }), _vm._v(" Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm.relatorios.length > 0) ? _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-question-circle icone_ajuda",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Clique aqui para iniciar o tutorial</h5>'
    },
    on: {
      "click": function($event) {
        _vm.configuracoes.tutorial.concluido = false;
        _vm.configuracoes.tutorial.passo = 1
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Projeto',
        href: '#'
      }, {
        text: 'Relatório de execução',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(!_vm.configuracoes.tutorial.concluido && _vm.relatorios.length > 0) ? _c('div', {
    staticClass: "row tutorial"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('vue-slider', {
    attrs: {
      "min": 1,
      "max": _vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7,
      "adsorb": true,
      "marks": true,
      "tooltip": 'none',
      "drag-on-click": true
    },
    on: {
      "drag-end": _vm.salvarConfiguracoes
    },
    scopedSlots: _vm._u([{
      key: "step",
      fn: function(ref) {
        var label = ref.label;
        var active = ref.active;

        return [_c('div', {
          class: ['passo', {
            active: active
          }]
        })]
      }
    }], null, false, 1904824845),
    model: {
      value: (_vm.configuracoes.tutorial.passo),
      callback: function($$v) {
        _vm.$set(_vm.configuracoes.tutorial, "passo", $$v)
      },
      expression: "configuracoes.tutorial.passo"
    }
  })], 1), _vm._v(" "), (_vm.configuracoes.tutorial.passo < (_vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7)) ? _c('div', {
    staticClass: "col-md-1 btn btn-default",
    on: {
      "click": function($event) {
        _vm.configuracoes.tutorial.passo++;
        _vm.salvarConfiguracoes()
      }
    }
  }, [_vm._v("Próximo "), _c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo !== (_vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7)) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "col-md-1 btn btn-default",
    attrs: {
      "title": '<h5>Ao clicar você fecha este tutorial sem concluí-lo.<br/>Para reabrí-lo basta clicar em <i class=\'fa fa-question-circle icone_ajuda\'></i> </h5>'
    },
    on: {
      "click": function($event) {
        _vm.configuracoes.tutorial.concluido = true;
        _vm.salvarConfiguracoes()
      }
    }
  }, [_vm._v("Pular "), _c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === (_vm.usuarioLogado.userType === 'FUNDACAO' ? 13 : 7)) ? _c('div', {
    staticClass: "col-md-2 btn btn-success",
    on: {
      "click": function($event) {
        _vm.configuracoes.tutorial.concluido = true;
        _vm.salvarConfiguracoes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entendi"), _c('br'), _vm._v("Clique para concluir")]) : _vm._e()])]), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 1) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 2) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 3) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 4) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 5) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 6) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 7) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 8) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 9) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 10) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 11) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 12) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.configuracoes.tutorial.passo === 13) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(13)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.blockStatusERP === true
    }
  }, [(_vm.configuracoes.tutorial.concluido) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.processando),
      expression: "loading.processando"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.loading.carregando) ? _c('span', [_vm._v("Carregando relatórios de execução...")]) : _c('span', [(_vm.relatorios.length === 0) ? _c('span', [_vm._v("Este projeto não tem Relatórios de Execução no SGP")]) : _vm._e(), _vm._v(" "), (_vm.relatorios.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.projeto.numero) + " - " + _vm._s(_vm.projeto.nome) + " "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('b', [_vm._v(_vm._s('(' + _vm.projeto.situacao_projeto + ')'))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (false) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        interactive: true,
        theme: 'light',
        position: 'bottom',
        maxWidth: '600px'
      }),
      expression: "{inertia: true, arrow: true, animation: 'fade', distance: '1', size: 'large', interactive: true, theme: 'light', position: 'bottom', maxWidth: '600px'}"
    }],
    staticClass: "legenda",
    attrs: {
      "title": (_vm.modoEdicao ?
        '<table class=\'table legenda_tabela borderless\'>' +
        '<tr><td style=\'font-weight: bold; background: #f5f5f5\'>Modo de Edição ativado:</td></tr>' +
        '<tr><td style=\' background: #f5f5f5\'>' +
        '<table class=\'table\'>' +
        '<tr><td style=\'background: #fbfbff\'>Relatório que não pode ser alterados</td></tr>' +
        '<tr><td class=\'success text-success\'>Relatório será Adicionado ao Concluir</td></tr>' +
        '<tr><td class=\'info text-info\'>Relatório terá datas Alteradas ao Concluir</td></tr>' +
        '<tr><td class=\'text-muted\' style=\'background: #e8e5e5\'>Relatório será Excluído ao Concluir</td></tr>' +
        '</table>' +
        '</td></tr>' +
        '</table>' :
        '<table class=\'table legenda_tabela\'>' +
        '<tr><td style=\'background: #f0f0ff\'>Fora do período de preenchimento</td></tr>' +
        '<tr><td style=\'background: ' + _vm.cor('pendente', 'corFundo') + '\'>No período e Pendente, em Análise ou Devolvido</td></tr>' +
        '<tr><td style=\'background: ' + _vm.cor('aprovado', 'corFundo') + '\'>Relatório aprovado</td></tr>' +
        '<tr><td style=\'background: ' + _vm.cor('não apresentado', 'corFundo') + '\'>Não apresentado no prazo</td></tr>' +
        (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.configuracoes.mostrarExcluidos ? '<tr><td style=\'background: ' + _vm.cor('excluído', 'corFundo') + '\'>Reatório excluído</td></tr>' : '') +
        '</table>'
      )
    }
  }, [_vm._v("\n                    Legenda\n                  ")]) : _vm._e()]), _vm._v(" "), (_vm.modoEdicao) ? _c('span', [_c('span', {
    staticClass: "col-md-10"
  }, [_c('br'), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novoRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-o",
    attrs: {
      "aria-label": "true"
    }
  }), _vm._v(" Incluir novo relatório")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(!_vm.loading.carregando && _vm.mostrarGantt && _vm.relatorios.length > 0) ? _c('div', {
    attrs: {
      "id": "gantt_relatorios"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    style: ('margin-bottom: 10px; ' + (_vm.modoEdicao ? 'background: #f5f5f5;' : ''))
  }, [_c('div', {
    style: ('width: ' + ((_vm.projeto.dias.duracao * _vm.configuracoes.zoom) + 35) + 'px;'),
    attrs: {
      "id": "bloco_relatorios"
    }
  }, [_c('div', {
    style: ('width: ' + ((_vm.projeto.dias.duracao * _vm.configuracoes.zoom) + 10) + 'px;'),
    attrs: {
      "id": "limites_projeto"
    }
  }, [_c('span', [_vm._v("Início em " + _vm._s(_vm.formataData(_vm.projeto.data_aprovacao_projeto)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Término em " + _vm._s(_vm.formataData(_vm.projeto.data_final_projeto)))])]), _vm._v(" "), (_vm.configuracoes.mostrarGrade) ? _c('div', {
    style: ('height: ' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 70) + 'px'),
    attrs: {
      "id": "grade_meses"
    }
  }, _vm._l((_vm.projeto.lista_meses), function(p) {
    return _c('div', {
      staticClass: "secao_periodo",
      style: ('margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, p) * _vm.configuracoes.zoom) + 'px; height: ' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 70) + 'px')
    }, [_c('div', {
      staticClass: "texto_vertical"
    }, [_vm._v(_vm._s(_vm._f("moment")(p, 'MMM/YY')))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    style: ('height: ' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 70) + 'px'),
    attrs: {
      "id": "grafico_relatorio"
    }
  }, [_vm._l((_vm.validacaoPeriodos), function(faixa) {
    return (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.projeto.dias.ateHoje <= (_vm.projeto.dias.duracao + 5)) ? _c('div', {
      staticClass: "validacao_periodo",
      style: ('margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, faixa.inicio) * _vm.configuracoes.zoom) + 'px;' +
        'width:' + (_vm.dias(faixa.inicio, faixa.termino) * _vm.configuracoes.zoom) + 'px;' +
        'height:' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 50) + 'px')
    }) : _vm._e()
  }), _vm._v(" "), (_vm.configuracoes.mostrarHoje) ? _c('div', {
    ref: "HOJE",
    staticClass: "linha_hoje",
    style: ('margin-left: ' + (_vm.projeto.dias.ateHoje * _vm.configuracoes.zoom) + 'px; height:' + ((_vm.qtdeRelatoriosTela * _vm.configuracoes.altura) + 50) + 'px')
  }, [_vm._v("\n                            Hoje " + _vm._s(_vm.projeto.dias.ateHoje > _vm.projeto.dias.duracao ? 'após ' + (_vm.projeto.dias.ateHoje - _vm.projeto.dias.duracao) + ' dia(s) do término do projeto' : '') + "\n                          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "barras_relatorios"
  }, _vm._l((_vm.relatorios), function(relatorio, indexRelatorio) {
    return (!_vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao) || (_vm.configuracoes.mostrarExcluidos && _vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao))) ? _c('div', {
      staticClass: "relatorio",
      style: ('height: ' + (_vm.configuracoes.altura) + 'px;' +
        'background: ' + _vm.realceAlteracao(relatorio)['cor'] + ';')
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          size: 'large',
          arrow: true,
          theme: 'light',
          placement: 'bottom',
          followCursor: true,
          distance: 40
        }),
        expression: "{inertia: true, arrow: true, animation: 'perspective', size: 'large', arrow: true, theme: 'light', placement: 'bottom', followCursor: true, distance: 40}"
      }],
      staticClass: "info_acao",
      style: ('height: ' + (_vm.configuracoes.altura - 5) + 'px;' +
        'width: ' + (_vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao) ? (60 * _vm.configuracoes.zoom) : (_vm.dias(relatorio.inicio_preenchimento, relatorio.termino_preenchimento) * _vm.configuracoes.zoom)) + 'px;' +
        'margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.inicio_preenchimento) * _vm.configuracoes.zoom) + 'px;' +
        ((!_vm.modoEdicao && _vm._.includes(['PREENCHER', 'REVISAR', 'VISUALIZAR'], relatorio.acao) || (_vm.modoEdicao && _vm.ehRelatorioEditavel(relatorio))) ? 'cursor: pointer;' : '') +

        (_vm.estaExcluido(relatorio) ? 'background: rgb(240, 240, 240, 0.8); z-index:400; border:1px solid white;' :
          (_vm.modoEdicao && !_vm.ehRelatorioEditavel(relatorio) ? 'background: rgb(255, 255, 255, 0.75); z-index:400;' :
            'background: ' + _vm.cor(relatorio.situacao, 'corFundo')))),
      attrs: {
        "title": '<h5>Relatório ' + relatorio.tipo + ' nº <b>' + relatorio.sequencia + '</b>' +
          '<br/><span style=\'font-weight: bold; background: ' + _vm.realceAlteracao(relatorio)['cor'] + '; color: ' + (_vm.cor(relatorio.situacao, 'corTexto')) + '\'>' + (relatorio.situacao).replace('ajustes:', 'ajustes<br/><br/>') + '</span>' +
          '<hr/>' +
          'Prazo de entrega<br/><span class=\'data_periodo_entre\'>' + _vm.formataData(relatorio.final_ciclo) + '</span>' +
          '<br/><br/>' +
          'Período disponível para análise<br/><span class=\'data_final_ciclo_em\'>' + _vm.formataDataDDMM(relatorio.antes_30_final_ciclo) + ' e ' + _vm.formataData(relatorio.depois_30_final_ciclo) + '</span>' +
          (_vm._.has(relatorio, 'apresentado_em') && (relatorio.apresentado_em !== '1900-01-01' && !_vm._.isNull(relatorio.apresentado_em)) ? '<br/><br/>Apresentado em<br/><span class=\'data_apresentado_em\'>' + _vm.formataData(relatorio.apresentado_em) + '</span>' : '') +
          (_vm._.has(relatorio, 'aprovado_em') && (relatorio.aprovado_em !== '1900-01-01' && !_vm._.isNull(relatorio.aprovado_em)) ? '<br/><br/>Aprovado em<br/><span class=\'data_aprovado_em\'>' + _vm.formataData(relatorio.aprovado_em) + '</span>' : '') +

          '<hr/><b>' +
          (
            !_vm.modoEdicao ? (relatorio.acao !== 'OCULTO' ? 'Clique para ' + _vm._.toLower(relatorio.acao) : '') :
            (_vm._.includes(['Não apresentado', 'Fora do período de preenchimento', 'Pendente de preenchimento', 'Relatório terá datas Alteradas ao Concluir', 'Relatório será Adicionado ao Concluir', 'Relatório será Excluído ao Concluir'], relatorio.situacao) || !_vm._.has(relatorio, 'situacao') ? 'Clique para alterar ou excluir cronograma' : '')
          ) + '</b>' +
          '</h5>'
      },
      on: {
        "click": function($event) {
          return _vm.clickAcaoBarra(relatorio)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "faixa_preenchimento",
      style: ('height: ' + (_vm.configuracoes.altura - 5) + 'px;' +
        'width: ' + (_vm._.includes(['Excluído via Sapiens', 'Excluído via SGP'], relatorio.situacao) ? (_vm.dias(relatorio.antes_30_final_ciclo, relatorio.depois_30_final_ciclo) * _vm.configuracoes.zoom) : (_vm.dias(relatorio.inicio_preenchimento, relatorio.termino_preenchimento) * _vm.configuracoes.zoom)) + 'px;' +
        'margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.inicio_preenchimento) * _vm.configuracoes.zoom) + 'px;')
    }), _vm._v(" "), _c('div', {
      staticClass: "faixa_regular",
      style: ('height: ' + (_vm.configuracoes.altura - 5) + 'px;' +
        'width: ' + (_vm.dias(relatorio.antes_30_final_ciclo, relatorio.depois_30_final_ciclo) * _vm.configuracoes.zoom) + 'px;' +
        'margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.antes_30_final_ciclo) * _vm.configuracoes.zoom) + 'px')
    }), _vm._v(" "), (_vm.modoEdicao && !_vm._.isNull(_vm.relatorioEditando) && _vm.relatorioEditando.sequencia === relatorio.sequencia) ? _c('div', {
      staticClass: "slider_alteracao_final_ciclo",
      style: ('margin-left: ' + (_vm.relatorioEditando.minimo * _vm.configuracoes.zoom) + 'px;' +
        'height: ' + (_vm.configuracoes.altura) + 'px;' +
        'padding-top: ' + (_vm.configuracoes.altura / 5) + 'px;' +
        'width: ' + ((_vm.relatorioEditando.maximo - _vm.relatorioEditando.minimo) * _vm.configuracoes.zoom) + 'px;')
    }, [_c('vue-slider', {
      attrs: {
        "process": false,
        "lazy": true,
        "tooltip-formatter": function (diasCorridos) { return _vm.formataData(_vm.adicionaDias(_vm.projeto.data_aprovacao_projeto, diasCorridos)); },
        "min": _vm.relatorioEditando.minimo,
        "max": _vm.relatorioEditando.maximo
      },
      on: {
        "drag-end": _vm.atualizaAlteracao,
        "blur": _vm.cancelaEdicao
      },
      model: {
        value: (_vm.relatorioEditando.alteracaoDias),
        callback: function($$v) {
          _vm.$set(_vm.relatorioEditando, "alteracaoDias", $$v)
        },
        expression: "relatorioEditando.alteracaoDias"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          theme: 'light'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, theme:'light'}"
      }],
      staticClass: "data_final_ciclo",
      style: ('margin-left: ' + (_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.final_ciclo) * _vm.configuracoes.zoom) + 'px;' +
        'height: ' + (_vm.configuracoes.altura - 5) + 'px;'),
      attrs: {
        "title": '<h5>Final de ciclo em<br/><span style=\'color: var(--cor-atencao-dark); font-weight: bold\'>' + _vm.formataData(relatorio.final_ciclo) + '</span></h5>'
      }
    }, [_vm._v(" ")]), _vm._v(" "), (_vm._.has(relatorio, 'apresentado_em') && (relatorio.apresentado_em !== '1900-01-01' && !_vm._.isNull(relatorio.apresentado_em))) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          theme: 'light'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, theme:'light'}"
      }],
      staticClass: "data_apresentacao",
      style: ('margin-left: ' + ((_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.apresentado_em) * _vm.configuracoes.zoom) + 2) + 'px;' +
        'height: ' + (_vm.configuracoes.altura - 5) + 'px;'),
      attrs: {
        "title": '<h5>Apresentado em<br/><span style=\'color: var(--cor-destaque-dark); font-weight: bold\'>' + _vm.formataData(relatorio.apresentado_em) + '</span></h5>'
      }
    }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm._.has(relatorio, 'aprovado_em') && (relatorio.aprovado_em !== '1900-01-01' && !_vm._.isNull(relatorio.aprovado_em))) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          theme: 'light'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, theme:'light'}"
      }],
      staticClass: "data_aprovacao",
      style: ('margin-left: ' + ((_vm.dias(_vm.projeto.data_aprovacao_projeto, relatorio.aprovado_em) * _vm.configuracoes.zoom) + 4) + 'px;' +
        'height: ' + (_vm.configuracoes.altura - 5) + 'px;'),
      attrs: {
        "title": '<h5>Aprovado em<br/><span style=\'color: var(--cor-sucesso-dark); font-weight: bold\'>' + _vm.formataData(relatorio.aprovado_em) + '</span></h5>'
      }
    }, [_vm._v(" ")]) : _vm._e()]) : _vm._e()
  }), 0)], 2)])])]), _vm._v(" "), (_vm.configuracoes.mostrarLegenda) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v("Legendas")]), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['fora do período'])) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#f0f0ff"
    },
    attrs: {
      "title": '<h5>Relatório que ainda não abriu o período de preenchimento</h5>'
    }
  }, [_vm._v("Fora do período")]) : _vm._e(), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['pendente', 'análise', 'devolvido'])) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#c0d4ff"
    },
    attrs: {
      "title": '<h5>Esta dentro do período e está Pendente de preenchimento ou em Análise ou está Devolvido para ajustes</h5>'
    }
  }, [_vm._v("No período")]) : _vm._e(), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['aprovado'])) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#c0f3d2"
    },
    attrs: {
      "title": '<h5>Relatório registrado como aprovado</h5>'
    }
  }, [_vm._v("Aprovado")]) : _vm._e(), _vm._v(" "), (_vm.haRelatoriosPelasSituacoes(['não apresentado'])) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#f3c0cc"
    },
    attrs: {
      "title": '<h5>Não apresentado e ainda disponível para preenchimento, mas que passou do prazo no período regular</h5>'
    }
  }, [_vm._v("Não apresentado")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.configuracoes.mostrarExcluidos && _vm.haRelatoriosPelasSituacoes(['excluído'])) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#e3e7ec"
    },
    attrs: {
      "title": '<h5>Foi excluído via Sapiens ou SGP e não é mais visível para entidade</h5>'
    }
  }, [_vm._v("Excluído")]) : _vm._e()]), _vm._v(" "), (_vm.modoEdicao) ? _c('tr', [_c('td', {
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v("Modo de Edição")]), _vm._v(" "), (_vm._.find(_vm.relatorios, function(rel) {
    return !_vm.ehRelatorioEditavel(rel)
  })) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "legenda_etiqueta",
    staticStyle: {
      "background": "#fbfbff"
    },
    attrs: {
      "title": '<h5>Relatório que não pode ser alterados</h5>'
    }
  }, [_vm._v("Não pode ser alterado")]) : _vm._e(), _vm._v(" "), (_vm.alteracao.incluidos.length > 0) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "success legenda_etiqueta",
    staticStyle: {
      "background": "#dff0d8"
    },
    attrs: {
      "title": '<h5>Relatório será Adicionado ao Concluir</h5>'
    }
  }, [_vm._v("Será Incluído")]) : _vm._e(), _vm._v(" "), (_vm.alteracao.alterados.length > 0) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "info legenda_etiqueta",
    staticStyle: {
      "background": "#d9edf7"
    },
    attrs: {
      "title": '<h5>Relatório terá datas Alteradas ao Concluir</h5>'
    }
  }, [_vm._v("Será Alterada Data")]) : _vm._e(), _vm._v(" "), (_vm.alteracao.excluidos.length > 0) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "text-muted legenda_etiqueta",
    staticStyle: {
      "background": "#e8e5e5"
    },
    attrs: {
      "title": '<h5>Relatório será Excluído ao Concluir</h5>'
    }
  }, [_vm._v("Será Excluído")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.validacaoPeriodos.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "background": "rgba(202, 123, 73, 0.38)"
    }
  }, [_vm._v("Atenção:")]), _vm._v(" "), _vm._l((_vm.validacaoPeriodos), function(faixa) {
    return _c('p', [_vm._v("Relatório nº "), _c('b', [_vm._v(_vm._s(faixa.relatorio1.sequencia))]), _vm._v(" - " + _vm._s(faixa.tipo) + " ( " + _vm._s(_vm.formataData(faixa.inicio)) + "  a  " + _vm._s(_vm.formataData(faixa.termino)) + ")")])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.relatorioEditando)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row well well-sm no-shadow"
  }, [_c('div', {
    staticClass: "col-md-12 form-group required-field",
    class: {
      'has-error': _vm.errors.first('final do ciclo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v(_vm._s(_vm._.has(_vm.relatorioEditando, 'id') ? 'Editando relatório ' + _vm.relatorioEditando.sequencia : 'Incluindo relatório novo') + " informe a data de Final do Ciclo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "final do ciclo",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": false,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy",
      "disabled-dates": _vm.desabilitarDatas
    },
    model: {
      value: (_vm.relatorioEditando.final_ciclo),
      callback: function($$v) {
        _vm.$set(_vm.relatorioEditando, "final_ciclo", $$v)
      },
      expression: "relatorioEditando.final_ciclo"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('final do ciclo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('final do ciclo')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.okEdicao
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelaEdicao
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.excluirRelatorio(_vm.relatorioEditando)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-label": "true"
    }
  }), _vm._v(" Excluir")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-md-offset-2"
  }, [_vm._v("\n                          Limitado a data de término do projeto de " + _vm._s(_vm.formataData(_vm.projeto.data_final_projeto)) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modoEdicao) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row well well-sm no-shadow"
  }, [_c('div', {
    staticClass: "col-md-12 form-group required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Justificativa " + _vm._s(_vm.alteracao.incluidos.length + _vm.alteracao.excluidos.length + _vm.alteracao.alterados.length > 1 ? 'das alterações' : 'da alteração') + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.alteracao.justificativa),
      expression: "alteracao.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa",
      "placeholder": "Descreva justificativa",
      "rows": "3",
      "data-vv-as": "Justificativa"
    },
    domProps: {
      "value": (_vm.alteracao.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.alteracao, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-2 col-md-10"
  }, [(_vm.alteracao.incluidos.length > 0 || _vm.alteracao.excluidos.length > 0 || _vm.alteracao.alterados.length > 0) ? _c('span', [_vm._v("\n                          Relatórios: " + _vm._s(_vm.alteracao.incluidos.length) + " incluído(s), " + _vm._s(_vm.alteracao.excluidos.length) + " excluídos(s), " + _vm._s(_vm.alteracao.alterados.length) + " alterados(s)\n                        ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "opcoes",
    on: {
      "click": function($event) {
        _vm.mostrarOpcoes = !_vm.mostrarOpcoes
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" Opções\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarOpcoes),
      expression: "mostrarOpcoes"
    }],
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Mostrar Excluídos:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarExcluidos),
      expression: "configuracoes.mostrarExcluidos"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarExcluidos"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarExcluidos, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarExcluidos", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarExcluidos),
      expression: "configuracoes.mostrarExcluidos"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarExcluidos"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarExcluidos, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarExcluidos", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Zoom períodos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 3,
      "interval": .1,
      "hide-label": true,
      "tooltip": 'none',
      "drag-on-click": true
    },
    on: {
      "drag-end": _vm.salvarConfiguracoes
    },
    scopedSlots: _vm._u([{
      key: "process",
      fn: function() {
        return [_c('div', {
          staticClass: "escalaZoom"
        })]
      },
      proxy: true
    }], null, false, 4023097680),
    model: {
      value: (_vm.configuracoes.zoom),
      callback: function($$v) {
        _vm.$set(_vm.configuracoes, "zoom", $$v)
      },
      expression: "configuracoes.zoom"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Altura da barra:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('vue-slider', {
    attrs: {
      "data": [{
        tamanho: 25,
        nome: 'Pequeno'
      }, {
        tamanho: 35,
        nome: 'Médio'
      }, {
        tamanho: 45,
        nome: 'Grande'
      }, {
        tamanho: 55,
        nome: 'Extra'
      }],
      "data-value": 'tamanho',
      "data-label": 'nome',
      "drag-on-click": true
    },
    on: {
      "drag-end": _vm.salvarConfiguracoes
    },
    model: {
      value: (_vm.configuracoes.altura),
      callback: function($$v) {
        _vm.$set(_vm.configuracoes, "altura", $$v)
      },
      expression: "configuracoes.altura"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Mostrar Grade:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarGrade),
      expression: "configuracoes.mostrarGrade"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarGrade"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarGrade, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarGrade", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarGrade),
      expression: "configuracoes.mostrarGrade"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarGrade"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarGrade, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarGrade", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Mostrar Hoje:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarHoje),
      expression: "configuracoes.mostrarHoje"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarHoje"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarHoje, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarHoje", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarHoje),
      expression: "configuracoes.mostrarHoje"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarHoje"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarHoje, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarHoje", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Mostrar Legenda:")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarLegenda),
      expression: "configuracoes.mostrarLegenda"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarLegenda"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.configuracoes.mostrarLegenda, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarLegenda", true)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Sim "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configuracoes.mostrarLegenda),
      expression: "configuracoes.mostrarLegenda"
    }],
    attrs: {
      "type": "radio",
      "name": "mostrarLegenda"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.configuracoes.mostrarLegenda, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.configuracoes, "mostrarLegenda", false)
      }, _vm.salvarConfiguracoes]
    }
  }), _vm._v(" Não "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat col-md-offset-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.configuracaoPadrao
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ao padrão")])])])]) : _vm._e()]) : _vm._e()])])])]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Tutorial\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\xanjyjeekdpghr5dgap4.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\o1hiqwks07hifa6aj1sz.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\ddjwqe25q3tphkgefoqj.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\jtoywuy44dq2zqzmtn5q.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\auxeh01iknrmk563kspi.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\f75fr57g1cf7h7jgk97p.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\m8ebsjo3k1lg1eou5an4.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\gq2b2bzvxje0raavrl72.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\zazzystmj2e41rktbkwo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\t0dymw64se3jbv1373a2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\pwdjofu0yqtgjb4ab5tv.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\yhxmo5y38646lwxf2v6d.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\tutoriais\\gv3ws0odkz1hak5bg6ql.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-529a583a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/ListaRelExec.vue
// module id = 1954
// module chunks = 1